import React from 'react';
import ZohoContactForm from '../ZohoContactForm/ZohoContactForm';

const Contactpage = () => {
    return (
        <section className="wpo-contact-pg-section section-padding">
            <div className="container">
                <div className="row">
                    <div className="col col-lg-10 offset-lg-1">
                        <div className="office-info">
                            <div className="row">
                                <div className="col col-xl-6 col-lg-6 col-md-6 col-12">
                                    <div className="office-info-item">
                                        <div className="office-info-icon">
                                            <div className="icon">
                                                <i className="fi flaticon-location-1"></i>
                                            </div>
                                        </div>
                                        <div className="office-info-text">
                                            <h2>Location</h2>
                                            <p>Florida</p>
                                        </div>
                                    </div>
                                </div>
                                <div className="col col-xl-6 col-lg-6 col-md-6 col-12">
                                    <div className="office-info-item">
                                        <div className="office-info-icon">
                                            <div className="icon">
                                                <i className="fi flaticon-email"></i>
                                            </div>
                                        </div>
                                        <div className="office-info-text">
                                            <h2>Email Us</h2>
                                            <p>info@dreugenepereira.com</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* Zoho Contact Form */}
                        <div style={{marginTop: '50px', marginBottom: '80px'}}>
                            <ZohoContactForm />
                        </div>
                    </div>
                </div>
            </div>
            <section className="wpo-contact-map-section" style={{marginTop: '60px'}}>
                <div className="wpo-contact-map">
                    <iframe
                        title='contact-map'
                        src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d56876.95520823301!2d-82.5931516!3d27.3364347!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x88c337b8e252d645%3A0x24ce43c8f08e5f0!2sSarasota%2C%20FL%2034236%2C%20USA!5e0!3m2!1sen!2sus!4v1650000000000"
                        style={{
                            border: 0,
                            width: '100%',
                            height: '450px'
                        }}
                        allowFullScreen
                        loading="lazy"
                    ></iframe>
                </div>
            </section>
        </section>
    )
}

export default Contactpage;
